import { render, staticRenderFns } from "./aprobar_button.vue?vue&type=template&id=16534f0d&lang=pug&"
import script from "./aprobar_button.vue?vue&type=script&lang=js&"
export * from "./aprobar_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports